<ion-header>
  <ion-toolbar class="ion-page-back">
    <img src="assets/images/page-back-icon.svg" class="page-back-icon" alt="page-back-icon" (click)="back.emit()" />
    <h1 [innerHtml]="pageTitle"></h1>
  </ion-toolbar>
</ion-header>
